<style scoped>
.hotel-name{
	padding-bottom: 10px;
	border-bottom: 1px solid #ddd;
}
.hotel-name .small-title {
    font-size: 15px;
    padding: 20px 0 0 10px;
		height: 45px;
    position: relative;
}

.hotel-name .small-title:before {
    content: "";
    position: absolute;
    left: 0;
    top: 25px;
    border-top: 5px solid transparent;
    border-right: 5px solid transparent;
    border-left: 6px solid #fe6d18;
    border-bottom: 5px solid transparent;
    z-index: 1;
}
.hotel-name-btn {

}
.info-list > p > .bold{
	font-weight: bold;
}
</style>

<template>
	<div>
	    <section class="order-main">
	        <div class="content">
	        	<div v-if="hotel">
		            <div class="hotel-name">
		                龙腾捷旅酒店预订单（CN）
										<div class="hotel-name-btn">
											<span class="back-btn" onclick="window.history.go(-1)">返回</span>
											<span class="check-btn" style="background: #139849;color: #fff; padding-left: 0px;" @click="isRemark=true">{{hotel['I'].OrderTypeId == 1&&hotel['I'].HandleStatesId==0?'接受/拒绝变更':hotel['I'].OrderTypeId == 2&&hotel['I'].HandleStatesId==0?"接受/拒绝取消":'酒店确认号'}}</span>
											
											<span v-if="hotel['I'].MainOrderStatus==27" style="background: #1478e4;color: #fff;padding-left: 0px;" class="check-btn" @click="checkStatus()">客人已入住</span>
											<span v-if="hotel['I'].MainOrderStatus==28" style="background: #1478e4;color: #fff;padding-left: 0px;" class="check-btn no-click">客人已入住</span>
											<span href="javascript:void(0)" class="print-btn" @click="routetoPage('orderPrint')">打印预订单</span>
										</div>
										<div class="small-title">{{hotel['I'].HotelName}}
											
											
										</div>
		            </div>
		            <!--startprint-->
		            <div class="order-info">
		                <!-- info-title -->
		                <div class="info-title">基础信息</div>
		                <div class="info-list">
		                    <p><label class="replace-label">订单号：</label>
		                    	{{hotel['I'].PurchaseOrderId}}
		                    	<label >({{hotel['I'].OrderType}})</label>
												<span class="copyOrderNumber" :data-clipboard-text="hotel['I'].PurchaseOrderId" @click="copyOrderNumber"></span>
		                    </p> 
												<p><label class="replace-label">确认号：</label>{{ConfirmNo}}</p>
		                    
		                    <p><label class="replace-label">住客名称：</label>{{hotel['I'].GuestName}} <span class="copyOrderNumber" :data-clipboard-text="hotel['I'].GuestName" @click="copyOrderNumber"></span></p>
												<p><label class="replace-label">入离时间：</label>{{hotel['I'].CheckIn|delUTC|dateToDvd}} - {{hotel['I'].CheckOut|delUTC|dateToDvd}} <span class="bold">	（{{getDaysSize(hotel['I'].CheckIn,hotel['I'].CheckOut)}}晚）</span></p>
												<p><label class="replace-label">总间夜数：</label><span class="bold">{{getDaysSize(hotel['I'].CheckIn,hotel['I'].CheckOut)*hotel['I'].RoomNum}}</span></p>
												<p><label class="replace-label">房间名称：</label> <span class="font-18 color-red">{{hotel['I'].RoomName}} <span class="bold">（{{hotel['I'].RoomNum}}间）</span></span></p>
												<p v-if="getDays(hotel['I'].CancelTime,hotel['I'].CreatTime)>0"><label class="replace-label">最晚取消时间：</label>{{hotel['I'].CancelTime|dateLong}}</p>
												<p v-else><label class="replace-label">最晚取消时间：</label></p>
												
		                    <p><label class="replace-label">特殊要求：</label><span class="color-red">{{hotel['I'].Notes||'无'}}</span></p>
		                    
		                </div>

		                <!-- info-title -->
		                <div class="info-title">房价信息</div>
		                <table cellspacing="0">
		                    <thead>
		                        <tr>
		                            <!-- <td>状态</td> -->
		                            <!-- <td>房型名称</td> -->
		                            <td>入住时间</td>
		                            <td>间数</td>
		                            <!-- <td>晚数</td> -->
		                            <td>含早情况</td>
		                            <td>币种</td>
		                            <td>房价</td>
		                        </tr>
		                    </thead>
		                    <tbody>
		                        <tr v-for="price in hotel.P">
		                            <!-- <td>新单</td> -->
		                            <!-- <td>{{price.RoomName}}</td> -->
		                            <td>{{price.CheckIn|delUTC|dateToLineDvd}}</td>
		                            <td>{{price.RoomNum}}</td>
		                            <!-- <td>{{getDaysSize(hotel['I'].CheckIn,hotel['I'].CheckOut)}}</td> -->
		                            <td>{{price.BreakFastName}}</td>
		                            <td>{{price.BaseCurrency}}</td>
		                            <td>{{price.BasePrice}}</td>
		                            

		                      
		                        </tr>
		                    </tbody>
		                </table>

		                <!-- title -->
		                <div class="info-title">附加费用信息</div>
		                <table cellspacing="0">
		                    <thead>
		                        <tr>
		                            <!-- <td>房型名称</td> -->
		                            <td>附加费用时间</td>
		                            <td>附加费用类型</td>
		                            <td>附加费用名称</td>
		                            <td>币种</td>
		                            <td>单价</td>
		                            <td>数量</td>
		                        </tr>
		                    </thead>
		                    <tbody>
		                        <tr v-for="overcase in hotel.S" v-if="hotel.S&&hotel.S.length>0">
		                           
		                            <!-- <td>{{overcase.RoomName}}</td> -->
		                            <td>{{overcase.SurchargeDate|delUTC|dateToLineDvd}}</td>
		                            <td>{{overcase.SurchargeTypeName}}</td>
		                            <td>{{overcase.SurchargeName}}</td>
		                            <td>{{overcase.BaseCurrency}}</td>
		                            <td>{{overcase.BasePrice}}</td>
		                            <td>{{overcase.SurchargeNum}}</td>
		                        </tr>
		                        <tr  v-if="!hotel.S||hotel.S.length<=0">
		                            <td colspan="9">暂无</td>
		                        </tr>
		                    </tbody>
		                </table>

		                <!-- title -->
		                <div class="info-title">合计</div>
		                <div class="total">
		                    <p>共计 <span class="font-18 color-red">{{hotel['I'].Currency}} {{hotel.TotalPrice}}</span>元</p>
		                    <p>付款方式：{{hotel['I'].SettlementName}}</p>
		                </div>
		                <!--endprint-->
		                <div class="order-remark mask" v-if="isRemark">
		                    <div class="e-form">
														<i class="e-form-close" @click="isRemark=false"></i>
		                        <div class="form-contorl">
		                            <label class="title">酒店确认号：</label>
		                            <input type="text" v-model="hotel['I'].ConfirmNo">
		                            <span class="color-red ">特殊符号可输入：","、"-"、";"、"#"</span>
		                        </div>
		                        <div class="form-contorl">
		                            <label class="title">备注：</label>
		                            <textarea name="" id="" rows="4" v-model="hotel['I'].ConfirmRemark"></textarea>
		                        </div>
		                        <div v-show="hotel['I'].HandleStatesId==0">

			                        <div class="form-contorl " v-show="hotel['I'].OrderTypeId == 0">
			                            <label class="title"></label>
			                            <div class="form-btn active"  @click="save('Confirm')" >接受预定</div>
			                            <div class="form-btn" @click="save('Reject')">拒绝预定</div>
			                        </div>
			                        <div class="form-contorl " v-show="hotel['I'].OrderTypeId == 1">
			                            <label class="title"></label>
			                            <div class="form-btn active"  @click="save('Confirm')" >接受变更</div>
			                            <div class="form-btn" @click="save('Reject')">拒绝变更</div>
			                        </div>
			                        <div class="form-contorl " v-show="hotel['I'].OrderTypeId == 2">
			                            <label class="title"></label>
			                            <div class="form-btn active"  @click="save('Confirm')" >接受取消</div>
			                            <div class="form-btn" @click="save('Reject')">拒绝取消</div>
			                        </div>
		                        </div>


		                        <div class="form-contorl " v-show="hotel['I'].HandleStatesId!=0">
		                            <label class="title"></label>
		                            <div class="form-btn active" @click="confrim">变更</div>
		                        </div>
		                    </div>
		                </div>
										<p style="text-align: right;color: #878787;margin:0;font-size:14px;"><label class="replace-label">制单人：</label>{{hotel['I'].RealName}}（电话：{{hotel['I'].Phone||'无'}}   传真：{{hotel['I'].Fax||'无'}}）</p>
		            </div>
						</div>
	        </div> 
	    </section>
	    <section class="section-footer">
	        <div class="content">
	            <p>国内产品：0755-82365588-1  香港产品：0755-82365588-2  海外产品：0755-82365588-3  澳门产品：0756-8281308</p>
	            <p>Copyright2013-2017,cnbooking.net.All rights reserved. <a href="https://beian.miit.gov.cn/">粤ICP备09018804号</a> <a href="https://beian.mps.gov.cn/#/query/webSearch"> <img style="vertical-align: sub;" src="./../../assets/images/element.png" alt=""> 粤公网安备 44030302000401号</a></p>
	        </div>
	    </section>
			<div class="mask" v-show="showRp">                        
				<div class="error-box">                        
					<h1>提示</h1>
					<h2>{{RpTxt}}</h2> 
					<h2 style="text-align: center;max-height: 200px;overflow-y: auto;" v-show="alertList.length">
						<div style="line-height: 1.5em;" v-for="item in alertList" :key="item.txt">{{ item.txt }}</div>
					</h2>                     
					<div @click="showRp=false">确定</div>                        
				</div>                        
			</div>
	</div>
</template>
<script>
import Clipboard from "clipboard";
export default {
	name:"orderEdit",
	data(){
		return{
	    	ebID:this.dao.get('ebID'),
	    	VerCol:this.dao.get('VerCol'),
	    	hotel:'',
				ConfirmNo:'',
				RpList:[],
				showRp:false,
				RpTxt:'',
				isRemark:false
				
		}
	},

		computed: {
			alertList() {
				return this.RpList
					.filter(r => {
						if (r.A) return false;
						const stock = r.SC != null ? r.SC : r.SSC   // 等价 SSC ?? SC
						return stock <= 1
					})
					.map(r => ({
						txt: r.PD.replace(/\//g,'-') +
								((r.SC != null ? r.SC : r.SSC) == 1
									? ' 只剩1间房，请及时补充库存；'
									: ' 已售罄，请及时补充库存；')
					}))
			}
		},
	methods:{
			// 计算日期差
			getDays(s1, s2) {
					const time1 = Date.parse(s1);
					const time2 = Date.parse(s2);
					var time = time1 - time2;
					return time;
			},
			copyOrderNumber() {
				var clipboard = new Clipboard(".copyOrderNumber");
				var that = this;
				clipboard.on("success", e => {
					// console.log('复制成功')
					that.error({ title: "提示", content: "复制成功" });
					// 释放内存
					clipboard.destroy();
				});
				clipboard.on("error", e => {
					// 不支持复制
					that.error({ title: "提示", content: "该浏览器不支持自动复制" });
					// console.log('该浏览器不支持自动复制')
					// 释放内存
					clipboard.destroy();
				});
			},
			checkStatus(){
				var that=this;
	      var params={
	          mainOrderId: that.hotel['I'].MainOrderId
	      }
	      that.isLoading=true;
	      that.getRequest({
	          url: that.Api.checkStatus,
	          params: params
	      }).then(res => {
	          that.isLoading=false;
	          if (res.IsSuccess) {
							that.initData()	
							that.error({ title: '提示', content: '状态更新成功' });
	          } else {
	            that.initData()
	            that.error({ title: '提示', content: '状态更新失败' });
	          }
	      });
			},
  		initData () {
	        var that=this;
	        var params={
	            ebID: that.ebID,
	            ver: that.VerCol
	        }
	        that.isLoading=true;
	        that.getRequest({
	            url: that.Api.getOrderList,
	            params: params
	        }).then(res => {
	           that.isLoading=false;
	            if (res) {
	                that.hotel=res;
									that.ConfirmNo = res["I"].ConfirmNo||"暂无"
							
									
	            } else {
	                that.hotel='';
	                that.error({ title: '提示', content: '没有查询到相关数据' });
	            }
	        });
	    },
			getRp(){
        var that=this;
				that.showRp = false 
        var params={
          hotel: that.hotel['I'].HotelId,
          room: that.hotel['I'].RoomId,
          rp: that.hotel['P'][0].RatePlanId,
          rate: that.hotel['P'][0].RateId,
          date: that.hotel['I'].CheckIn.slice(0, 10).replace(/-/g, ''),
          endDate:that.hotel['I'].CheckOut.slice(0, 10).replace(/-/g, '')
        }
        that.getRequest({
          url: that.Api.getRp,
          params: params
        }).then(res => {
					that.showRp = true
        	if (res && res.length>0) {
            that.RpList = res  
          }
        });
      },
  		save (type) {
	        var that=this;
	        var params={
	            EBID: that.ebID,
	            ConfirmNO: that.hotel['I'].ConfirmNo,
	            Remark: that.hotel['I'].ConfirmRemark,
	            Ver: that.VerCol,
	        }
	       
	        that.isSaving=true;
	        that.patchRequest({
	            url: that.Api.getOrderList+'/'+type,
	            params: params
	        }).then(res => {
	        	that.isSaving=false;
						that.isRemark=false;
	            if (res) {
								if(that.hotel['I'].OrderTypeId == 0){
									that.RpTxt = res.Msg
									that.getRp()
									that.initData();
								}else{
									that.error({ title: '提示', content: res.Msg });
	            		that.initData();
								}
	            	
	            } else {
	                that.error({ title: '提示', content: '没有执行成功，请重试' });
	            }
	        });
	    },
	    PrintOrder() {   
		   // var bdhtml=window.document.body.innerHTML;   
		   // var sprnstr="<!--startprint-->";   
		   // var eprnstr="<!--endprint-->";   
		   // var prnhtml=bdhtml.substr(bdhtml.indexOf(sprnstr)+17);   
		   //  prnhtml=prnhtml.substring(0,prnhtml.indexOf(eprnstr)); 
		   //  console.log(prnhtml);  
		   //  window.document.body.innerHTML=prnhtml;  
		    window.print();   
		},
		confrim () {
	        var that=this;
	        if(!that.hotel['I'].ConfirmNo&&!that.hotel['I'].ConfirmRemark){
	        	that.error({ title: '提示', content: '请输入酒店确认号或备注' });
	        	return;
	        }
	        var params={
	            EBID: that.ebID,
	            Ver:that.VerCol,
	            ConfirmNO: that.hotel['I'].ConfirmNo,
	            Remark: that.hotel['I'].ConfirmRemark
	        }
	        that.isSaving=true;
	        that.patchRequest({
	            url: that.Api.updateConfrim,
	            params: params
	        }).then(res => {
	        
	        	that.isSaving=false;
						that.isRemark=false;
	            if (res) {
	            	that.error({ title: '提示', content: res.Msg });
								window.history.go(-1);
	            } else {
	              that.error({ title: '提示', content: '没有执行成功，请重试' });
	            }
	        });
	    }
		
	},
	mounted(){
		this.initData();

	}
}

	
</script>


// WEBPACK FOOTER //
// src/components/order/OrderEdit.vue